//angular imports
import { ChangeDetectionStrategy, Component, signal, WritableSignal } from '@angular/core';


//local imports
import { CatalogConstants, DepartmentModel } from '@app/catalog';
import { BreadcrumbItemToggleMessage, IBreadcrumbItemModel, Messenger, PresenterType } from '@app/shared';
import { Subject } from 'rxjs';

@PresenterType({
  model: DepartmentModel,
  key: 'tileTop'
})
@Component({
  selector: 'department-carousel-item',
  templateUrl: './department-carousel-item.component.html',
  styleUrl: './department-carousel-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DepartmentCarouselItemComponent {
  public data: WritableSignal<DepartmentModel> = signal<DepartmentModel>(undefined);

  private readonly destroying$ = new Subject<void>();


  constructor(private messenger: Messenger)
  {}

  public addToBreadCrumb(item: IBreadcrumbItemModel) {
    if(!this.data().shouldAddBreadcrumb()) {
      return;
    }
    this.messenger.send(new BreadcrumbItemToggleMessage(item, CatalogConstants.CATALOG));
  }

  ngOnDestroy() {
    this.destroying$.next(undefined);
    this.destroying$.complete();
  }
}
